import React, { useEffect, useState } from 'react'
import { DrListTable } from '../../../_metronic/layout/components/RhEALComponent'
import { useDebounce } from '../../../_metronic/layout/components/RhEALComponent';
const DrList = () => {

    const [myLoading, setMyLoading] = useState<boolean>(false);
    const [deleteDr, setDeleteDr] = useState<boolean>(false);
    const [DrListData, setDrListData] = useState<any[]>([])
    const [exportDrListData, setExportDrListData] = useState<any[]>([])
    const [isExport, setIsExport] = useState(false);
    const [pageNumber, setPageNumber] = useState<number>(1)
    const [totalRecords, setTotalRecords] = useState<number>(0)
    const [searchResult, setSearchResult] = useState<string>("");
    const [filterData, setFilterData] = useState<string>("")

    const debounceVal = useDebounce(searchResult, 700);
    const limit = 8;

    useEffect(() => {
        getDrList()
    }, [filterData, pageNumber, debounceVal, deleteDr]);

    useEffect(() => {
        getExportDrList();
    }, []);

    const getDrList = () => {

        setMyLoading(true);

        const getMRObj = {
            method: "get_doctor_list",
            page: pageNumber,
            limit: limit,
            employee_id: filterData,
            searchDoctName: debounceVal,
        };
        fetch(`${process.env.REACT_APP_API_URL_MAIN}get_doctor_list`, {
            method: "POST",
            headers: {},
            body: JSON.stringify(getMRObj),
        })
            .then((result) => {
                result.json().then((response) => {
                    if (response.status === 1) {
                        setDrListData(response?.data);
                        setTotalRecords(response?.total_records)
                        setMyLoading(false);
                    } else {
                        setMyLoading(false);
                    }
                });
            })
            .catch(() => {
                setMyLoading(false);
            });
    };

    const getExportDrList = () => {
        const getMRObj = {
            method: "get_doctor_list",
        };
        fetch(`${process.env.REACT_APP_API_URL_MAIN}get_doctor_list`, {
            method: "POST",
            headers: {},
            body: JSON.stringify(getMRObj),
        })
            .then((result) => {
                result.json().then((response) => {
                    if (response.status === 1) {
                        setExportDrListData(response?.data);
                        setIsExport(true);
                    }
                });
            })
            .catch(() => { });
    };

    return (
        <>
            <DrListTable data={DrListData} isExport={isExport} exportDrListData={exportDrListData} totalRecords={totalRecords} loading={myLoading} setSearchResult={setSearchResult} deleteDr={deleteDr} setDeleteDr={setDeleteDr} setPageNumber={setPageNumber} pageNumber={pageNumber} limit={limit} setFilterData={setFilterData} filterData={filterData} />
        </>
    )
}

export default DrList